import React, { PropsWithChildren, useContext, useState } from 'react'
import { OnboardingStep } from '../types/onboarding-types'
import { authState } from '../state/auth-state'
import { getAccountOnboardingStatus } from '../utilities/account'
import ToastAlert from '../elements/toast-alert'

export const OnboardingContext = React.createContext<{
  onboardingStatus?: OnboardingStep
  currentStep?: OnboardingStep
  setCurrentStep: React.Dispatch<React.SetStateAction<OnboardingStep>>
  setError: React.Dispatch<React.SetStateAction<string>>
}>({
  setCurrentStep: () => {},
  setError: () => {}
})

export const OnboardingPageProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { account, accountLoading } = authState()
  const [currentStep, setCurrentStep] = useState<OnboardingStep>()
  const [onboardingStatus, setOnboardingStatus] = useState<OnboardingStep>()
  const [error, setError] = useState<string | null>(null)

  React.useEffect(() => {
    if (!accountLoading && account) {
      const onboardingStatus = getAccountOnboardingStatus(account)
      setOnboardingStatus(onboardingStatus)
    }
  }, [account, accountLoading])

  const value = React.useMemo(
    () => ({
      onboardingStatus,
      currentStep,
      setCurrentStep,
      setError
    }),
    [currentStep, onboardingStatus]
  )

  return (
    <OnboardingContext.Provider value={value}>
      {children}
      <ToastAlert
        open={error != null}
        onClose={() => setError(undefined)}
        message={error}
        type={'error'}
      />
    </OnboardingContext.Provider>
  )
}

export const onboardingState = () => useContext(OnboardingContext)
